import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,

} from "recharts";
import { _formatAxisPrice, _axisWidth } from "./chartAxis";
const CustomBarChart = ({ theme, data}) => {
  const maxValue = Math.max(...data.map((item) => item.value));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barCategoryGap={2} margin={{ left: 10 }}>
        <XAxis
          dataKey="name"
          axisLine={{ stroke: "none" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
          
        />
        <YAxis
          axisLine={{ stroke: "none" }}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            textAnchor: "end",
            fontWeight: 600,
            dx: 5, 
          }}
          
          domain={[0, maxValue]}
          tickLine={false}
          width={_axisWidth([maxValue], 20)}
          tickFormatter={_formatAxisPrice}
        />
        <Bar
          dataKey="value"
          className="bar-element-chart"
          barSize={80}
          radius={[32,32,0,0]}
        >
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
